import { CalendarBlank, Envelope } from '@phosphor-icons/react';
import { useT } from '../../hooks/useTranslation';
import { BOOKING_DISABLED, FALLBACK_EMAIL } from '../../config/maintenance';
import { trackEvent } from '../../utils/analytics';
import { useScrollDriven, pageProgress, ramp } from '../../hooks/useScrollDriven';

// A hero alatt (az oldal 8–12%-ától) úszik be, és a legalján ki is úszik: a lábléc jobb
// alsó sarkában ül az adatkezelési link, amit a gomb eltakart volna.
const ctaVars = (y: number, vh: number) => {
  const prog = pageProgress(y, vh);
  const p = ramp(prog, 0.08, 0.12) * (1 - ramp(prog, 0.96, 0.995));
  return {
    '--cta-o': p.toFixed(3),
    '--cta-y': `${(20 * (1 - p)).toFixed(1)}px`,
    '--cta-pe': p < 0.05 ? 'none' : 'auto',
  };
};

const CLASS =
  // A pointer-events CSS-változóból jön: láthatatlan állapotban ne fogja el a kattintást
  // a mögötte lévő linkektől (adatkezelési tájékoztató a lábléc sarkában).
  '[pointer-events:var(--cta-pe,auto)] fixed bottom-8 right-8 z-50 bg-forest/95 backdrop-blur-sm text-sand px-6 py-4 shadow-xl shadow-black/20 border border-gold/40 hover:bg-forest hover:border-gold/80 transition-colors duration-300 flex items-center gap-3 group';
const STYLE = { opacity: 'var(--cta-o, 0)', transform: 'translateY(var(--cta-y, 20px))' } as const;

export const StickyBookingCTA = () => {
  const t = useT();
  const ref = useScrollDriven<HTMLElement>(ctaVars);

  const handleClick = () => {
    const el = document.querySelector('#booking');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  if (BOOKING_DISABLED) {
    return (
      <a
        ref={ref as React.RefObject<HTMLAnchorElement>}
        style={STYLE}
        href={`mailto:${FALLBACK_EMAIL}?subject=Foglalási%20érdeklődés%20—%20haaziko.`}
        onClick={() => trackEvent('booking_inquiry_email', { placement: 'sticky_cta' })}
        className={CLASS}
      >
        <Envelope size={18} className="group-hover:-rotate-6 transition-transform" weight="duotone" />
        <span className="uppercase tracking-widest text-xs font-medium">Írj nekünk</span>
      </a>
    );
  }

  return (
    <button ref={ref as React.RefObject<HTMLButtonElement>} style={STYLE} onClick={handleClick} className={CLASS}>
      <CalendarBlank size={18} className="group-hover:rotate-12 transition-transform" />
      <span className="uppercase tracking-widest text-xs font-medium">{t.stickyCta}</span>
    </button>
  );
};
